import { Injectable } from '@angular/core';
import {Http, Response, Headers} from '@angular/http';

@Injectable()
export class LoggerService {
  logs: string[] = [];

  constructor(private http:Http) { }

  log(message: string) {
    const logEntry = `${new Date().toISOString()}: ${message}`;
    const logsAsJson = JSON.stringify(logEntry, null, 2);

    // Envía el log al servidor
    this.http.post('https://embeddedapi.segurosmedicosinternacionales.com.co/logWebSmi', { logTransaccion: [logsAsJson] }).subscribe(
      response => console.log(response),
      error => console.error('Error al enviar log al servidor:', error)
    );
  }

  warn(message: string) {
    console.warn(`WARN: ${message}`);
  }

  error(message: string) {
    console.error(`ERROR: ${message}`);
  }
}


// WEBPACK FOOTER //
// ./src/app/services/extra/logger.service.ts